module.exports = __webpack_public_path__ + "img/movistar-es.035e5597.png";